// Serviço de solicitações do usuário: busca os requerimentos do usuário logado
// na API de Protocolo (GET /protocolo/listar/{pessoaId}).

import { authService, protocoloService } from '../../../services';

const getPessoaId = (user) => {
  const token = authService.getToken();

  if (token) {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      if (payload.pessoaId) return payload.pessoaId;
    } catch (e) {
      // token inválido, cai no fallback abaixo
    }
  }

  return user?.pessoaId || user?.PessoaID || null;
};

export const userRequestsService = {
  async getRequests() {
    const user = authService.getCurrentUser();
    const pessoaId = getPessoaId(user);

    if (!pessoaId) {
      return { success: false, error: 'Não foi possível identificar o usuário logado.' };
    }

    try {
      const data = await protocoloService.listarProtocolosPorPessoa(pessoaId);
      return { success: true, data };
    } catch (error) {
      return { success: false, error: error.message || 'Erro ao carregar solicitações' };
    }
  }
};
